<template>
    <div class="rank_box">
        <div class="r_data">
            <h5>排序维度：</h5>
            <div class="sort_select" id="sortSelect" @click.stop>
                <div class="data_tit">
                    <div class="data_default" @click="change">请选择<i :class="isShow ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></div>
                    <ul class="dropdown" id="sortUl" style="height:0px;">
                        <li v-for="(item,index) in selectData" :key="index" @click="checkSelect(index)">
                            <input type="checkbox" :checked="item.isChecked" />{{item.name}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="divide "></div>
            <div class="sort_box">
                <div class="data_tit" v-for="(ite,i) in selectList" :key="i" @click="remove(i)">{{ite.name}}<i
                        class="el-icon-close"></i></div>
            </div>
            <div class="sort_rank" :class="isSort ? 'current' : ''" v-if="JSON.stringify(selectedData) != '{}'" @click="orderField">
                <i></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
         props: ['sortList'],
        data() {
            return {
                isShow: false,
                selectData: [],
                selectedData: {},
                selectList:[],
                isSort: true
            };
        },
        mounted() {
            let vm = this;
            vm.sortList.forEach(element => {
                element.isChecked = false;
                vm.selectData.push(element);
            });

            document.body.addEventListener('click', () => {
                vm.isShow = false;
                let div = document.getElementById('sortUl');
                if(div != null){
                    let div_height = div.offsetHeight;
                    if (div_height) {
                        vm.toggleSlide('sortUl', '500');
                    }
                }
            }, false);
        },
        methods: {
            change() {
                let vm = this;
                vm.isShow = !vm.isShow;
                vm.toggleSlide('sortUl', '500');
            },
            toggleSlide(id, s) {
            let div = document.querySelector('#' + id);
            div.style.transition = 'height ' + s + 'ms';
           div.style.overflow = 'hidden';
         // 使用 setTimeout 延迟获取高度
          setTimeout(() => {
           let div_height = div.offsetHeight;
           if (div_height) {
           div.style.height = '0';
           div.style.border = "none";
           } else {
           div.style.height = '100px';
           div.style.border = "1px solid #bed2e5";
           div.style.borderTop = "none";
         }
       }, 0);
       },
            checkSelect(index) {
                let vm = this,
                    pData = {};
                vm.$forceUpdate();
                vm.$set(vm.selectData[index], "isChecked", !vm.selectData[index].isChecked);
                if(vm.selectData[index].isChecked){
                    vm.selectList.push(vm.selectData[index]);
                }else{
                    vm.selectList.forEach((ele,j) =>{
                    if(ele.value == vm.selectData[index].value){
                        vm.selectList.splice(j,1);
                    }
                });
                }
                pData = vm.getParams();
                vm.$emit('selectedData', pData);
            },
            remove(i) {
                let vm = this,
                    pData = {};
                vm.selectData.forEach((ele,j) =>{
                    if(ele.value == vm.selectList[i].value){
                        vm.$set(vm.selectData[j], 'isChecked', !vm.selectData[j].isChecked);
                    }
                });
                vm.selectList.splice(i,1);
                vm.$forceUpdate();
                pData = vm.getParams();
                vm.$emit('selectedData', pData);
            },
            orderField() {
                let vm = this, pData = {};
                vm.$set(vm, 'isSort', !vm.isSort);
                vm.$forceUpdate();
                pData = vm.getParams();
                vm.$emit('selectedData', pData);
            },
            getParams() {
                let vm = this,
                    orderType = 'desc';
                vm.selectedData = {};//重置
                vm.selectList.forEach(element => {
                    vm.selectedData[element.value] = orderType;
                });
                if (JSON.stringify(vm.selectedData) == "{}"){
                    orderType = 'desc';
                    vm.isSort = true;
                } else {
                    if (vm.isSort) {
                        orderType = 'desc';
                    } else {
                        orderType = 'asc';
                    }
                }
                for(let key in vm.selectedData){
                    vm.selectedData[key] = orderType;
                }
                return vm.selectedData;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" scoped>
    // @import "src/style/common";
    .data_title {
        height: 25px;
        border: solid 1px #c9d7e8;
        text-align: center;
        display: inline-block;
        float: left;
        border-radius: 3px;
        margin: 0 4px;
        position: relative;
        cursor: pointer;
        background: #f4f9fd;
    }

    .rank_box {
        float: left;
        padding: 8px 0;
        height: 25px;

        .r_data {
            float: left;
            color: #3b455f;
            font-size: 12px;

            h5 {
                font-weight: normal;
                line-height: 25px;
                float: left;
                color:#333333;
            }
            .sort_select {
                float: left;

                .data_tit {
                    @extend .data_title;
                    width: 90px;

                    .data_default {
                        line-height: 25px;
                    }

                    .dropdown {
                        position: absolute;
                        top: 26px;
                        left: -1px;
                        border-top: none;
                        width: 90px;
                        z-index: 20;
                        background: #fff;
                        height: 0px;
                        overflow: hidden;

                        li {
                            width: 95%;
                            margin-left: 0px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: left;
                            line-height: 25px;
                            background: #fbfbfb;
                            cursor: pointer;

                            input {
                                vertical-align: middle;
                                margin: 0 10px;
                            }
                        }
                    }
                }
            }

            .divide {
                float: left;
                line-height: 25px;
            }

            .sort_box {
                float: left;
                color: #3b455f;

                .data_tit {
                    @extend .data_title;
                    line-height: 25px;
                    padding: 0px 10px;
                }
            }

            .sort_rank {
                float: left;
                line-height: 32px;
                cursor: pointer;
                display: inline-block;

                i {
                    width: 9px;
                    height: 13px;
                    background: url("./../../assets/images/rank.png") no-repeat;
                    display: inline-block;
                    margin-left: 4px;
                    margin-top: 8px;
                }

            }

            .current i {
                background: url("./../../assets/images/rank1.png") no-repeat;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/views/Components/Sort.vue